import Tracker from "./Tracker";
import { register } from "./polyfill";

require("intersection-observer");

export function entry(init?: boolean): Tracker {
    register();

    const tracker: Tracker = new Tracker();

    if (init !== false) {
        requestAnimationFrame(tracker.init.bind(tracker));
    }

    window["vTracker"] = tracker;

    // 兼容旧版SDK暴露的接口
    // 兼容新旧版本并存，旧的方法已经在了不要覆盖
    if (typeof window["reportAlgorithm"] === "undefined") {
        window["reportAlgorithm"] = tracker.reportAlgorithm.bind(tracker);
        window["getUrl"] = tracker.getUrl.bind(tracker);
        window["setAppid"] = tracker.setAppid.bind(tracker);
        window["getTraceIndex"] = tracker.getTraceIndex.bind(tracker);
    }

    return tracker;
}

export default entry(
    typeof globalThis === "undefined" ||
        typeof globalThis.process === "undefined"
);
